import { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import ProgressBar from "react-topbar-progress-indicator";
import Cookies from "js-cookie";

import { LayoutAuth, LayoutDefault } from "./components/Layout";
import SignIn from "./pages/SignIn";
import Monitoring from "./pages/Monitoring";
// import Dashboard from "./pages/Dashboard"; // hidden until built (see /dashboard route below)
import Device from "./pages/Device";
import Support from "./pages/Support";
import Profile from "./pages/ProfileNew";
import AccountSetting from "./pages/AccountSetting";
import DeviceDetail2 from "./pages/DeviceDetail2";
import Empty from "./pages/Empty";
import TemperatureDetail from "./pages/TempartureDetail";
import OperationDetail from "./pages/OperationDetail";
import IotDetail from "./pages/IotDetail";
import PowerDetail from "./pages/PowerDetail";
import Notfound from "./pages/Notfound";

// The session is alive while EITHER token cookie survives. This used to read
// the access cookie alone — which lives 7 days while the refresh lives 14 —
// so every page-open in days 8..14 bounced straight to /signin with a
// perfectly valid refresh token sitting in the jar: the reactive-refresh
// interceptor never got a request to run on. (Proven on production: after
// deleting only jwt_token_control and reloading, the app landed on /signin
// with the refresh cookie intact — SignOut never ran, this guard did.)
// Accepting the refresh cookie lets the app render; the first API call then
// 401s, the interceptor mints a new access token, and the request retries —
// the 7-day bounce becomes a silent recovery.
const canAuth =
  (Cookies?.get("jwt_token_control") ?? "") ||
  (Cookies?.get("jwt_refresh_token_control") ?? "");

const RoutesComponent = () => {
  const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const location = useLocation();
    if (!canAuth) {
      return <Navigate to="/signin" state={{ from: location }} replace />;
    }
    return children;
  };

  const NotRequireAuth = ({ children }: { children: JSX.Element }) => {
    const location = useLocation();
    if (canAuth) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  };
  return (
    <Router>
      <Suspense fallback={<ProgressBar />}>
        <Routes>
          <Route path="/" element={<Navigate replace to="/monitoring" />} />
          <Route
            path="/monitoring"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <Monitoring />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          {/* Dashboard ("ภาพรวม") is hidden until built — it only shows the
              Coming placeholder. Redirect direct hits to /monitoring instead of
              stranding on the placeholder. Restore the <Dashboard /> element
              (and the sidebar <Link> in Layout/Default.tsx) when it ships. */}
          <Route
            path="/dashboard"
            element={<Navigate replace to="/monitoring" />}
          />
          <Route
            path="/devices"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <Device />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            path="/support"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <Support />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            path="/profile"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <Profile />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            path="/account-setting"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <AccountSetting />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            // path="/device-detail/:locationID/:id"
            path="/device-detail/:id"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <DeviceDetail2 />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            // path="/device-detail/:locationID/:id/temperature"
            path="/device-detail/:id/temperature"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <TemperatureDetail />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            // path="/device-detail/:locationID/:id/operation"
            path="/device-detail/:id/operation"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <OperationDetail />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            // path="/device-detail/:locationID/:id/power"
            path="/device-detail/:id/power"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <PowerDetail />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            // path="/device-detail/:locationID/:id/iot"
            path="/device-detail/:id/iot"
            element={
              <RequireAuth>
                <LayoutDefault>
                  <IotDetail />
                </LayoutDefault>
              </RequireAuth>
            }
          />
          <Route
            path="/signin"
            element={
              <NotRequireAuth>
                <LayoutAuth>
                  <SignIn />
                </LayoutAuth>
              </NotRequireAuth>
            }
          />
          <Route path="/404" element={<Notfound />} />
          <Route path="*" element={<Empty />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RoutesComponent;
